export default __webpack_public_path__ + "11e0b3b447e11a3ed58c13168b180f2d.svg";